import { initOptions } from '@gp/utils/common';
import { DEFAULT_STAGE_VALUE_OVERVIEW } from '@gp/constants/const';
import { STAGE_OPT } from '@gp/pages/Workspace/Product/components/GameOverview/utils/constant';

export const getOptionsAndValues = (
  list?: string[],
): {
  options: any[];
  values: string[];
} => {
  if (!Array.isArray(list) || !list.length) return { options: [], values: [] };
  const options = initOptions(list);
  const values = [];
  for (const item of list) {
    values.push(item);
  }
  return { options, values };
};

export const getStageOptionsAndValues = (
  list?: string[],
): {
  options: any[];
  values: string[];
} => {
  const options = [];
  const values = [];
  for (const stage of STAGE_OPT) {
    if (!list?.includes(stage?.value?.toLowerCase())) continue;
    options.push({ ...stage, groupKey: 'separated', label: stage?.text || '' });
  }
  for (const stageValue of DEFAULT_STAGE_VALUE_OVERVIEW) {
    if (!list?.includes(stageValue?.toLowerCase())) continue;
    values.push(stageValue);
  }
  return { options, values };
};
